module.exports = __webpack_public_path__ + "img/Flag_of_Egypt.98f7dcbe.svg";